
import{FC} from 'external/react'

import usePackage from 'context/package-context/hook'
import Icon from 'external/fortawesome'

type AddUserButtonProps = {
	role: 'Student' | 'Tutor',
}

const AddUserButton: FC<AddUserButtonProps> = props => {

	const {role} = props

	const {update} = usePackage()

	function handleAdduser() {
		update({modals: {[`add${role}`]: {open: {$set: true}}}})
	}


    return (
        <div className='col-lg-2 col-md-2 col-2'>
            <button className='btn btn-primary w-100' onClick={handleAdduser} >
                <Icon name='faUserPlus' />
            </button>
        </div>
	)

}

export {AddUserButton as default}